import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  scrolled?: boolean;
}

export default function Navbar({ scrolled: scrolledProp }: NavbarProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(scrolledProp ?? false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    if (isHomePage) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMenuOpen(false);
      }
    } else {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="cursor-pointer">
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/f7c8e59443071922ab03ad54f161aa96.png"
              alt="سماعتي"
              className={`h-[6rem] w-auto transition-all duration-500 ${
                scrolled ? '' : 'brightness-0 invert'
              }`}
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`font-semibold transition-colors cursor-pointer text-base whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-[#184187]' : 'text-white hover:text-gray-200'
              }`}
            >
              الرئيسية
            </Link>
            <Link
              to="/about"
              className={`font-semibold transition-colors cursor-pointer text-base whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-[#184187]' : 'text-white hover:text-gray-200'
              }`}
            >
              من نحن
            </Link>
            <Link
              to="/services"
              className={`font-semibold transition-colors cursor-pointer text-base whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-[#184187]' : 'text-white hover:text-gray-200'
              }`}
            >
              خدماتنا
            </Link>
            <Link
              to="/careers"
              className={`font-semibold transition-colors cursor-pointer text-base whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-[#184187]' : 'text-white hover:text-gray-200'
              }`}
            >
              التوظيف
            </Link>
            <Link
              to="/contact"
              className="bg-[#184187] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#0f2d6b] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer text-base"
            >
              تواصل معنا
            </Link>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`md:hidden cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden bg-white shadow-lg overflow-hidden transition-all duration-500 ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="container mx-auto px-4 py-4 space-y-3">
          <Link
            to="/"
            onClick={() => setIsMenuOpen(false)}
            className="block w-full text-right py-2 text-gray-700 hover:text-[#184187] font-medium cursor-pointer text-base"
          >
            الرئيسية
          </Link>
          <Link
            to="/about"
            onClick={() => setIsMenuOpen(false)}
            className="block w-full text-right py-2 text-gray-700 hover:text-[#184187] font-medium cursor-pointer text-base"
          >
            من نحن
          </Link>
          <Link
            to="/services"
            onClick={() => setIsMenuOpen(false)}
            className="block w-full text-right py-2 text-gray-700 hover:text-[#184187] font-medium cursor-pointer text-base"
          >
            خدماتنا
          </Link>
          <Link
            to="/careers"
            onClick={() => setIsMenuOpen(false)}
            className="block w-full text-right py-2 text-gray-700 hover:text-[#184187] font-medium cursor-pointer text-base"
          >
            التوظيف
          </Link>
          <Link
            to="/contact"
            onClick={() => setIsMenuOpen(false)}
            className="block w-full text-right py-2 px-4 bg-[#184187] text-white rounded-lg font-medium hover:bg-[#0f2d6b] cursor-pointer text-base"
          >
            تواصل معنا
          </Link>
        </div>
      </div>
    </nav>
  );
}
